import { ArticleCtaType } from "@olagg/db-types"
import { AdminArticleCtasEndpoints } from "../endpoints/adminEndpoints"
import { fetcher } from "../fetcher"
import { useToast } from "@chakra-ui/react"
import { IUseArticleCtas } from "../interfaces/IUseArticleCtas"
import { useQ } from "./useQ"
import { useState } from "react"

export const useAdminArticleCtas = (filter: IUseArticleCtas) => {
  const toast = useToast();
  const [articleCta, setArticleCta] = useState<ArticleCtaType>();

  const response = useQ<{ articleCtas: ArticleCtaType[], meta: { count: number } }>(
    AdminArticleCtasEndpoints.all(filter)
  );

  const success_toast = (description: string) => {
    toast({
      title: 'CTAs de Novedades',
      colorScheme: 'olaggPink',
      status: 'success',
      description,
      position: 'bottom-right'
    });
  }

  const error_toast = (error: any) => {
    const reason = error?.errors || error?.error;
    // El backend devuelve el mismo "unauthorized" para "no sos admin" y para "tu
    // rol no tiene este modulo", y el segundo caso es el unico que se puede
    // resolver desde team: decir cual es ahorra una vuelta entera.
    const description = reason === 'unauthorized'
      ? 'Tu rol no tiene permiso sobre el módulo "CTAs de Novedades". Revisalo en Permisos → Roles y permisos: el permiso se da por rol, no por usuario.'
      : reason;

    toast({
      title: 'Error',
      colorScheme: 'olaggYellow',
      status: 'error',
      description,
      position: 'bottom-right'
    });
  }

  const createArticleCta = async (data: Partial<ArticleCtaType>, callback: () => void) => {
    return await fetcher(AdminArticleCtasEndpoints.create(data))
      .then(() => {
        success_toast('CTA creado con éxito');
        response.mutate();
        callback();
      })
      .catch((error: any) => {
        error_toast(error);
      })
  }

  const updateArticleCta = async (id: number, data: Partial<ArticleCtaType>, callback?: () => void) => {
    return await fetcher(AdminArticleCtasEndpoints.update(id, data))
      .then(() => {
        success_toast('CTA actualizado con éxito');
        response.mutate();
        callback?.();
      })
      .catch((error: any) => {
        error_toast(error);
      })
  }

  const deleteArticleCta = async (id: number) => (
    fetcher(AdminArticleCtasEndpoints.delete(id))
      .then(() => {
        success_toast('CTA eliminado con éxito');
        response.mutate();
      })
      .catch((error: any) => {
        error_toast(error);
      })
  )

  const find = (id: number) => {
    fetcher(AdminArticleCtasEndpoints.find(id))
      .then(res => setArticleCta(res.articleCta))
  }

  return {
    ...response,
    articleCta,
    find,
    createArticleCta,
    updateArticleCta,
    deleteArticleCta,
  }
}
